var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C8.86377 1 9.79565 1 10.5307 1.30448C11.5108 1.71046 12.2895 2.48915 12.6955 3.46927C13 4.20435 13 5.13623 13 7V7C13 8.86377 13 9.79565 12.6955 10.5307C12.2895 11.5108 11.5108 12.2895 10.5307 12.6955C9.79565 13 8.86377 13 7 13V13C5.13623 13 4.20435 13 3.46927 12.6955C2.48915 12.2895 1.71046 11.5108 1.30448 10.5307C1 9.79565 1 8.86377 1 7V7C1 5.13623 1 4.20435 1.30448 3.46927C1.71046 2.48915 2.48915 1.71046 3.46927 1.30448C4.20435 1 5.13623 1 7 1V1Z",
    stroke: "#171D40",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOutlineIcon);
export default __webpack_public_path__ + "static/media/checkBoxOutlineIcon.0616ad5f639484f7515e5d5455ee3e4e.svg";
export { ForwardRef as ReactComponent };